/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Failed_ExpiredInputs */

const en_mcp_connect_failed_expired = /** @type {(inputs: Mcp_Connect_Failed_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This connection request expired or couldn’t be approved.`)
};

const es_mcp_connect_failed_expired = /** @type {(inputs: Mcp_Connect_Failed_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta solicitud de conexión caducó o no se pudo aprobar.`)
};

/**
* | output |
* | --- |
* | "This connection request expired or couldn’t be approved." |
*
* @param {Mcp_Connect_Failed_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_failed_expired = /** @type {((inputs?: Mcp_Connect_Failed_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Failed_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_failed_expired(inputs)
	return en_mcp_connect_failed_expired(inputs)
});